import request from "@/utils/request";

// DRC 链路
const DRC_API_PREFIX = "/uav/control";
const workspaceId: string = localStorage.getItem("Workspace_id") || "";
const HTTP_PREFIX = '/uav/manage'

export interface PostDrcBody {
  clientId?: string; // token过期时，用于续期则必填
  expireTime?: number; // 过期时间，单位秒，默认3600
}

export interface DrcParams {
  address: string;
  username: string;
  password: string;
  clientId: string;
  expireTime: number; // 过期时间
  enableTls: boolean; // 是否开启tls
}

// 获取 mqtt 连接认证
export async function postDrc(
  params: any,
  body: PostDrcBody
): Promise<DrcParams> {
  console.log(workspaceId, params.workspaceId);
  const resp = await request.post(
    `${DRC_API_PREFIX}/drc/connect`,
    body
  );
  return resp.data;
}

export interface DrcEnterBody {
  clientId: string;
  dockSn: string;
  expireSec?: number; // 过期时间，单位秒，默认3600
  deviceInfo?: {
    osdFrequency?: number;
    hsiFrequency?: number;
  };
}

export interface DrcEnterResp {
  sub: string[]; // 需要订阅接收的topic
  pub: string[]; // 推送的topic地址
}

// 进入飞行控制 （建立drc连接&获取云控控制权）
export async function postDrcEnter(
  params: any,
  body: DrcEnterBody
): Promise<DrcEnterResp> {
  const resp = await request.post(
    `${DRC_API_PREFIX}/drc/enter`,
    body
  );
  return resp.data;
}

export const changeLivestreamLens = async function (body: {}): Promise<any> {
  const url = `${HTTP_PREFIX}/live/streams/switch`
  const result = await request.post(url, body)
  return result.data
}

export interface DrcExitBody {
  clientId: string;
  dockSn: string;
  expireSec: number;
}

// 退出飞行控制 （退出drc连接&退出云控控制权）
export async function postDrcExit(
  body: DrcExitBody
): Promise<null> {
  const resp = await request.post(
    `${DRC_API_PREFIX}/drc/exit`,
    body
  );
  return resp.data;
}

/**
 * 喊话器管理列表
 *
 * @param data
 */
export const getShoutList = async (body: any): Promise<any> => {
  const url = `/uav/manage/speakerContent/list`;
  const result = await request.post(url,body);
  return result.data;
};

/**
 * 无人机喊话内容保存
 *
 * @param data
 */
export const addSpeaker = async (body: any): Promise<any> => {
  const url = `/uav/manage/deviceSpeakerContent/add`;
  const result = await request.post(url,body);
  return result.data;
};

/**
 * 无人机喊话内容修改
 *
 * @param data
 */
export const modifySpeaker = async (body: any): Promise<any> => {
  const url = `/uav/manage/deviceSpeakerContent/modify`;
  const result = await request.post(url,body);
  return result.data;
};

/**
 * 无人机喊话内容查询
 *
 * @param data
 */
export const speakerInfo = async (deviceSn: any): Promise<any> => {
  const url = `/uav/manage/deviceSpeakerContent/info/` + deviceSn;
  const result = await request.post(url);
  return result.data;
};

/**
 * 开始喊话
 *
 * @param data
 */
export const speakerAudioPlayStart = async (body: any): Promise<any> => {
  const url = `/uav/control/speaker/speakerTtsPlayStart`;
  const result = await request.post(url,body);
  return result.data;
};

/**
 * 停止喊话
 *
 * @param data
 */
export const speakerPlayStop = async (body: any): Promise<any> => {
  const url = `/uav/control/speaker/speakerTtsPlayStop`;
  const result = await request.post(url,body);
  return result.data;
};

/**
 * 爆闪灯
 *
 * @param data
 */
export const drcLightModeSet = async (body: any): Promise<any> => {
  const url = `/uav/control/strobeLight/control`;
  const result = await request.post(url,body);
  return result.data;
};
